import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { RouteDefinition } from './Eftpos';
import Tippy from '@tippyjs/react';
import { Colors } from '../../Abstracts/Style/Colors';

export const BreadCrumbs = (props: { routes: RouteDefinition[]; rootName: string }) => {
	const { routes, rootName } = props;

	const filteredRoutes = routes.filter((x) => x.route !== '/' && x.excludeFromDropdown !== true);

	return (
		<BreadCrumbsList>
			<li>
				<Link to={'/'}>{rootName}</Link>
			</li>
			<Switch>
				{filteredRoutes.map((route) => {
					return (
						<Route key={route.name} path={route.route}>
							<BreadCrumb route={route} allRoutes={filteredRoutes} />
						</Route>
					);
				})}
			</Switch>
		</BreadCrumbsList>
	);
};

const BreadCrumb = (props: { route: RouteDefinition; allRoutes?: RouteDefinition[] }) => {
	const { route, allRoutes } = props;

	const { path } = useRouteMatch();

	const nameContent = <span className={route.routes !== undefined ? 'parent' : ''}>{route.name}</span>;

	return (
		<>
			<li>
				{allRoutes !== undefined && allRoutes.length > 1 ? (
					<Tooltip
						content={
							<OtherLinks>
								{allRoutes.map((x) => (
									<OtherLinksLink to={x.route} key={x.route} selected={x.route === path}>
										{x.name}
									</OtherLinksLink>
								))}
							</OtherLinks>
						}
						offset={[0, -2]}
						duration={[0, 0]}
						placement={'bottom-start'}
						interactive={true}
						appendTo={document.body}
					>
						{nameContent}
					</Tooltip>
				) : (
					nameContent
				)}
			</li>
			{route.routes !== undefined && (
				<Switch>
					{route.routes
						.filter((x) => x.route !== '/')
						.map((subRoute) => {
							return (
								<Route key={subRoute.name} path={path + subRoute.route}>
									<BreadCrumb
										route={subRoute}
										allRoutes={route.routes
											?.filter((x) => x.route !== '/' && x.excludeFromDropdown !== true)
											.map((x) => ({
												...x,
												route: path + x.route,
											}))}
									/>
								</Route>
							);
						})}
				</Switch>
			)}
		</>
	);
};

const OtherLinksLink = styled(Link)<{ selected: boolean }>`
	color: ${(props) => (props.selected ? Colors.gray7 : 'black')};
	text-decoration: none !important;
	padding: 0.5rem 1rem;
	background: ${(props) => (props.selected ? Colors.gray2 : 'transparent')};

	&:hover {
		color: ${Colors.gray6};
		background: ${Colors.gray1};
	}

	&:focus {
		outline: none;
		color: black;
	}
`;

const OtherLinks = styled.div`
	display: flex;
	flex-direction: column;
`;

const Tooltip = styled(Tippy)`
	background: ${Colors.white};
	color: white;
	padding: 0;
	border-radius: 0.25rem;

	min-width: 150px;

	.tippy-content {
		padding: 0;
	}

	.tippy-arrow {
		color: ${Colors.white};
		display: none;
	}

	box-shadow: 0px 0px 25px #00000040;
`;

const BreadCrumbsList = styled.ul`
	font-size: 28px;
	margin-block: 24px 12px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	list-style: none;
	padding: 0;

	li a,
	li span.parent {
		color: #000;
		text-decoration: none;
		font-weight: 700;

		&:hover {
			color: #767676;
			cursor: pointer;
		}
	}

	li + li::before {
		content: '/';
		padding: 0 8px;
		color: #b7b7b7;
	}
`;

interface BackButtonProps {
	to: string;
	text?: string;
	className?: string;
}

export const BackButton = (props: BackButtonProps) => {
	const { to, text = 'Back', className } = props;
	return (
		<BackBtn className={`${className !== undefined ? className : ''}`} to={to}>
			<i className="fa fa-arrow-left fa-lg" />
			{text}
		</BackBtn>
	);
};

const BackBtn = styled(Link)`
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-bottom: 1rem;
	align-self: flex-start;
	text-decoration: none !important;

	color: #000;

	i {
		margin-right: 1rem;
	}
`;
